import React from 'react'
import { useSelector } from 'react-redux';

function Medical() {
    const applicationData = useSelector((state)=> state.appViewDetailsSlice);

    const displayPatientsCurrentMedicationList = () => {
        let currentMedicalList = [];
        if (applicationData?.treatingPhysician?.PatientsCurrentMedicationList && applicationData?.treatingPhysician?.PatientsCurrentMedicationList.length > 0) {
            applicationData?.treatingPhysician?.PatientsCurrentMedicationList.map((data) => {
                if (data.DrugName == "Other") {
                    currentMedicalList.push(applicationData?.treatingPhysician?.OtherDrugName)
                } else {
                    currentMedicalList.push(data.DrugName);
                }
            })
        }
        const uniqueValue = [...new Set(currentMedicalList)]
        return uniqueValue.join(",");
    }

  return (
    <div>    <div class="intro-y box mt-lg-5">
    <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
        <h2 class="fw-medium fs-base me-auto">
            Medical Information
        </h2>
    </div>
    <div class="d-flex flex-column flex-lg-row p-5 pb-10  mx-n5 row">
         <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
             <div class="d-flex flex-column  mt-3">
                <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Physicain Name : <div class="text-gray-600 px-2">{applicationData.treatingPhysician.fullName} </div></div>
                <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2"> Primary Diagnosis : <div class="text-gray-600 px-2">{applicationData.treatingPhysician.primaryDiagnosis}</div></div>
            </div>
        </div>
            <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
            <div class="d-flex flex-column  mt-3">
                <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Facility : <div class="text-gray-600 px-2"> {applicationData.treatingPhysician.facilityName}</div> </div>

            </div>
        </div>
        <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
            <div class="d-flex flex-column  mt-3">
                <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Date of Diagnosis : <div class="text-gray-600 px-2">{applicationData.treatingPhysician.dateOfDiagnosis}</div></div>
               
           </div>
       </div>
    </div>
    <div class="d-flex flex-column flex-lg-row p-5 pb-10 mx-n5 row">
    <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
        <div class="d-flex flex-column  mt-3">
           <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Address Line 1 : <div class="text-gray-600 px-2">{applicationData.treatingPhysician.addressLine1} </div></div>
           <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2"> State : <div class="text-gray-600 px-2">{applicationData.treatingPhysician.state}</div></div>
       </div>
   </div>
       <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
       <div class="d-flex flex-column  mt-3">
           <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Address Line 2 : <div class="text-gray-600 px-2">{applicationData.treatingPhysician.addressLine2}</div> </div>
           <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Zipcode : <div class="text-gray-600 px-2">{applicationData.treatingPhysician.zipCode}</div></div>

       </div>
   </div>
   <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
       <div class="d-flex flex-column  mt-3">
           <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> City : <div class="text-gray-600 px-2">{applicationData.treatingPhysician.city} </div></div>
          
      </div>
  </div>
</div>
          {applicationData.program == "CPR" && typeof applicationData?.treatingPhysician?.PatientsCurrentMedicationList != "undefined" && applicationData?.treatingPhysician?.PatientsCurrentMedicationList.length > 0 && <div class="d-flex flex-column flex-lg-row p-5 pb-10  mx-n5 row">
              <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">Patient’s Current Medication (Related to Diagnosis) : <div class="text-gray-600 px-2">{displayPatientsCurrentMedicationList()}</div></div>
          </div>}
</div></div>
  )
}

export default Medical